import { get } from "lodash";
import { useMemo } from "react";
import { usePermissions } from "ra-core";

const usePrivileges = ({ record }) => {
  const { permissions, loaded } = usePermissions();
  const isResearcher = loaded && permissions(["researcher"]);
  return useMemo(() => {
    const state = get(record, "transaction.state", get(record, "state"));
    const canView = !isResearcher || state === "sent";
    return { canView };
  }, [record, isResearcher]);
};

export default usePrivileges;
